// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoomBox_wrapper__1LmKj","title":"RoomBox_title__1uKDN","team_name":"RoomBox_team_name__ug28G"};